import React, {Component} from 'react';
import './App.css';
import 'semantic-ui-css/semantic.min.css';
import ReactJson from 'react-json-view'

class CreditCard extends Component {

    constructor(props) {
        super(props)
        this.state = {
            cardNumber: "",
            expMonth: "",
            expYear: "",
            cardCode: "",
            opaqueData: {}
        }
    }

    paymentFormUpdate(opaqueData) {
        console.log("IN paymentFormUpdate " + Date.now());
        console.log(opaqueData);
        this.setState({opaqueData})
    }

    responseHandler(response) {
        console.log(Date.now());
        console.log(response);
        if (response.messages.resultCode === "Error") {
            console.log("Got an error " + Date.now());
            var i = 0;
            while (i < response.messages.message.length) {
                console.log(
                    response.messages.message[i].code + ": " +
                    response.messages.message[i].text
                );
                i = i + 1;
            }
        } else {
            console.log("Calling paymentFormUpdate " + Date.now());
            this.paymentFormUpdate(response.opaqueData);
            // console.log("Setting setState with opaqueData " + Date.now());
            // console.log(response.opaqueData);
            // this.setState(response.opaqueData)
        }
    }

    sendPaymentDataToAnet() {
        console.log("Calling sendPaymentDataToAnet " + Date.now());
        var authData = {};
        authData.clientKey = "44Ke883yu8nL8V7vaEfQ5T7NL6L8qKv7PXYPk3D4setG3QagdEkxuhkbEM8gQN7k";
        authData.apiLoginID = "67sBR2QfH2";
        var cardData = {};
        cardData.cardNumber = this.state.cardNumber
        cardData.month = this.state.expMonth
        cardData.year = this.state.expYear
        cardData.cardCode = this.state.cardCode

        var secureData = {};
        secureData.authData = authData;
        secureData.cardData = cardData;

        //window.Accept.dispatchData(secureData, this.responseHandler);
        window.Accept.dispatchData(secureData, this.responseHandler.bind(this));
    }

    changeHandler(key) {
        return (e) => {
            let state = this.state
            state[key] = e.target.value
            this.setState(state)
        }
    }

    render() {
        return (
            <div className="App">

                <div className="App-intro">
                    <form id="paymentForm"
                          method="POST"
                          action="https://YourServer/PathToExistingPaymentProcessingScript">
                        <input type="text" name="cardNumber" id="cardNumber" placeholder="cardNumber"
                               onChange={this.changeHandler("cardNumber")}/> <br/><br/>
                        <input type="text" name="expMonth" id="expMonth" placeholder="expMonth"
                               onChange={this.changeHandler("expMonth")}/> <br/><br/>
                        <input type="text" name="expYear" id="expYear" placeholder="expYear"
                               onChange={this.changeHandler("expYear")}/> <br/><br/>
                        <input type="text" name="cardCode" id="cardCode" placeholder="cardCode"
                               onChange={this.changeHandler("cardCode")}/> <br/><br/>
                        <input type="text" name="nameOnAccount" id="nameOnAccount" placeholder="nameOnAccount"
                               onChange={this.changeHandler("nameOnAccount")}/>
                        <br/><br/>
                        <input type="text" name="accountType" id="accountType" placeholder="accountType"
                               onChange={this.changeHandler("accountType")}/> <br/><br/>
                        <input type="hidden" name="dataValue" id="dataValue"/>
                        <input type="hidden" name="dataDescriptor" id="dataDescriptor"/>
                        <button type="button" onClick={this.sendPaymentDataToAnet.bind(this)}>Pay</button>
                        <ReactJson src={this.state.opaqueData} theme="monokai"/>
                    </form>
                </div>
            </div>
        );
    }
}

export default CreditCard;



// WEBPACK FOOTER //
// ./src/containers/CreditCard.js